import { deleteRole } from "../../../../CastingBotFirebase";
import SubTabNoData from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabTable from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabTable";
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons";

function ViewRolesTab(props) {

  const userData = props.userData;
  const castingData = props.extraData;
  const setCastingData = props.setExtraData;

  const header = ['Name', 'Size', 'Gender']
  const body = _parseToTable(castingData.roles);

  const handleDelete = (i) => {
    deleteRole(castingData.roles[i], userData.active_organisation_id, castingData.uid, setCastingData);
  }

  if(body.length > 0) 
  {
    return (
      <SubTabParent passData={props}>
        <SubTabTable header={header} body={body} deleteFunction={handleDelete} numbered />
      </SubTabParent>
    ) 
  }
  else 
  {
    return (
      <SubTabNoData 
        icon={faPlusSquare} 
        title='No Roles' 
        description='Add roles to see them here' 
      />
    )
  }

}

export default ViewRolesTab;



const _parseToTable = (roles) => {
  let roleArray = roles.map((role) => {
    return [...[role.name, role.size, role.gender]];
  })
  return roleArray;
}